(function () {
    'use strict';

    function assignAccountManagersController($scope, $log, sessionDataService, crmActionsDataService,
        configurationOptionsDataService, accountManagerDataService, platformEntitiesDataService,
        notifyService) {

            var self = this;

            this.entityId = null;
            this.entityType = '';

            this.assignedAccountManagers = [];
            this.accountManagersData = {};

            this.accountManagerTypes = [];

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                self.entityId = toParams.entityId;


                sessionDataService.loadSession().then(function (sessionData) {
                    configurationOptionsDataService.loadConfigurationOptions(sessionData.SiteName).then(function (configurationOptionsData) {
                        self.accountManagerTypes = configurationOptionsData.AccountManagerTypes;
                        $log.debug(self.accountManagerTypes);

                        accountManagerDataService.loadAll().then(function (accountManagers) {
                            self.accountManagersData = accountManagers;
                            platformEntitiesDataService.loadPlatformEntity(self.entityId).then(function (entity) {
                                self.assignedAccountManagers = entity.AssignedAccountManagers;
                                self.entityType = entity.EntityType;
                            });
                        });

                    });
                });
            });


            this.addAssignedAccountManager = function () {
                this.assignedAccountManagers.push({});
            };

            this.saveAssignedAccountManagers = function () {
                if ($scope.assignAccountManagersForm.$valid) {
                    crmActionsDataService.assignAccountManagers(self.entityId, angular.toJson(self.assignedAccountManagers)).then(
                        function (contractor) {
                            notifyService.notify('Your changes were saved successfully');
                        });
                }
                else {
                    alert('invalid data');
                }
            };
    }

    assignAccountManagersController.$inject = ['$scope', '$log', 'sessionDataService', 'crmActionsDataService',
    'configurationOptionsDataService', 'accountManagerDataService',
    'platformEntitiesDataService', 'notifyService'];

    angular.module('ecap.crm').controller('assignAccountManagersController', assignAccountManagersController);
})();
